import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStages(options = {}) {

	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGES,
		options
	)
}
function _getRegulationsStagePreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE_PREVIEW,
		options
	)
}
function _getRegulationsStagePopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE_POPUP,
		options
	)
}

function _createRegulationsStage(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].CREATE_REGULATIONS_STAGE,
		options
	)
}

function _getRegulationsStage(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE,
		options
	)
}

function _patchRegulationsStage(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].PATCH_REGULATIONS_STAGE,
		options
	)
}

function _putRegulationsStage(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].PUT_REGULATIONS_STAGE,
		options
	)
}

function _deleteRegulationsStage(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].DELETE_REGULATIONS_STAGE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGES]: _getRegulationsStages,

	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE_PREVIEW]: _getRegulationsStagePreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE_POPUP]: _getRegulationsStagePopup,

	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].CREATE_REGULATIONS_STAGE]: _createRegulationsStage,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].GET_REGULATIONS_STAGE]: _getRegulationsStage,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].PATCH_REGULATIONS_STAGE]: _patchRegulationsStage,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].PUT_REGULATIONS_STAGE]: _putRegulationsStage,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES].DELETE_REGULATIONS_STAGE]: _deleteRegulationsStage,
}